export default "<svg viewBox=\"0 0 14.37 14.37\"><line x1=\"1\" y1=\"1\" x2=\"13.37\" y2=\"13.37\"/><line x1=\"13.37\" y1=\"1\" x2=\"1\" y2=\"13.37\"/></svg>";